import { resolveFormatter } from '../utils/formatterRegistry';

interface HistoryFormattedValueProps {
    fieldKey: string;
    value: unknown;
}

export const HistoryFormattedValue = ({
    fieldKey,
    value,
}: HistoryFormattedValueProps) => {
    const FormatterComponent = resolveFormatter(fieldKey, value);
    return <FormatterComponent fieldKey={fieldKey} value={value} />;
};
